module.exports = __webpack_public_path__ + "img/warning.f2dfe28d.svg";